import { useRef, useEffect } from "react";

const useFocusTrap = (contentRef, focusDelay = 0, isFocusTrapActive = true) => {
  const previousFocusRef = useRef();

  useEffect(() => {
    if (isFocusTrapActive) {
      let timeout;
      previousFocusRef.current = document.activeElement;
      if (contentRef.current) {
        timeout = setTimeout(() => {
          contentRef.current.focus();
          timeout = null;
        }, focusDelay);
      }

      const isNext = (event) => event.keyCode === 9 && !event.shiftKey;
      const isPrevious = (event) => event.keyCode === 9 && event.shiftKey;
      const trapFocusListener = (event) => {
        if (contentRef.current.contains(event.target)) {
          const focusable = contentRef.current.querySelectorAll(
            "a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[tabindex], *[contenteditable]"
          );
          const first = focusable[0];
          const last = focusable[focusable.length - 1];
          if (isNext(event) && event.target === last) {
            event.preventDefault();
            first.focus();
          } else if (isPrevious(event) && event.target === first) {
            event.preventDefault();
            last.focus();
          }
        }
      };
      document.addEventListener("keydown", trapFocusListener);

      return () => {
        document.removeEventListener("keydown", trapFocusListener);
        if (timeout) {
          clearTimeout(timeout);
        }
      };
    }
  }, [contentRef, focusDelay, isFocusTrapActive]);

  return () => {
    previousFocusRef.current && previousFocusRef.current.focus();
  };
};

export default useFocusTrap;
